"use client";

import { useTranslations } from "next-intl";
import { MegaMenu } from "./MegaMenu";
import { IllustrationVisual } from "./IllustrationVisual";
import { PackagesIllustration } from "./illustrations/PackagesIllustration";
import { CustomIllustration } from "./illustrations/CustomIllustration";
import { CareIllustration } from "./illustrations/CareIllustration";

/**
 * Three pricing concepts shown in the nav: the fixed-price packages (websites
 * and iPhone apps), bespoke/native work by quote, and the monthly care plan.
 * (The Pricing section itself breaks these into per-offering cards.)
 */
const MENU = [
  { key: "packages", Illustration: PackagesIllustration },
  { key: "custom", Illustration: CustomIllustration },
  { key: "care", Illustration: CareIllustration },
] as const;

/** "Pricing" mega menu — one illustrated card per pricing concept. */
export function PricingMegaMenu() {
  const t = useTranslations("header");
  const tPricing = useTranslations("pricing");
  return (
    <MegaMenu
      label={t("nav.pricing")}
      items={MENU.map(({ key, Illustration }) => ({
        key,
        href: "#pricing",
        visual: (
          <IllustrationVisual>
            <Illustration />
          </IllustrationVisual>
        ),
        title: `${tPricing(`menu.${key}.name`)} — ${tPricing(`menu.${key}.price`)}`,
        detail: tPricing(`menu.${key}.tagline`),
        cta: t("pricingCta"),
      }))}
    />
  );
}
